<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :items-per-page="20"
    class="elevation-1"
    :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
    :no-data-text="emptyText"
    disable-sort
  >
    <template v-slot:item.requestedAt="{ item }">
      {{ item.requestedAt | moment('DD/MM/YYYY HH:mm') }}
    </template>

    <template v-slot:item.exportType="{ item }">
      {{ exportTypeLabel(item) }}
    </template>

    <template v-slot:item.contrato="{ item }">
      {{ (item.filters && item.filters.contratoName) || 'Todos los contratos' }}
    </template>

    <template v-slot:item.estados="{ item }">
      <span v-if="!hasStatusFilter(item)" class="grey--text">No aplica</span>
      <div v-else-if="filterStatusCodes(item).length" class="d-flex align-center flex-wrap py-2" style="gap: 6px; row-gap: 4px;">
        <membership-status-chip
          v-for="code in filterStatusCodes(item)"
          :key="code"
          :status="code"
        ></membership-status-chip>
      </div>
      <span v-else class="grey--text">Todos los estados</span>
    </template>

    <template v-slot:item.state="{ item }">
      <v-chip small :color="stateMeta(item.state).color" class="white--text font-weight-bold">
        <v-icon small left>{{ stateMeta(item.state).icon }}</v-icon>
        {{ stateMeta(item.state).label }}
      </v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn
        small
        text
        color="primary"
        :disabled="!isReady(item)"
        @click="$emit('download', item.id)"
      >
        Descargar
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import MembershipStatusChip from './MembershipStatusChip';
import { EXPORT_REQUEST_STATUS, EXPORT_TYPES } from '../utils/constants';

const EXPORT_TYPE_LABELS = {
  [EXPORT_TYPES.MEMBERSHIPS]: 'Membresías',
  [EXPORT_TYPES.USERS]: 'Usuarios',
  [EXPORT_TYPES.PET_HEALTH]: 'Vacunas atrasadas'
};

const STATE_META = {
  [EXPORT_REQUEST_STATUS.PENDING]: { label: 'Pendiente/Procesando', color: 'orange', icon: 'mdi-clock-outline' },
  [EXPORT_REQUEST_STATUS.READY]: { label: 'Lista', color: 'green', icon: 'mdi-check-circle-outline' },
  [EXPORT_REQUEST_STATUS.FAILED]: { label: 'Fallida', color: 'red', icon: 'mdi-alert-circle-outline' }
};

export default {
  name: 'ExportRequestsTable',
  components: {
    MembershipStatusChip
  },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  computed: {
    headers() {
      return [
        { text: 'Fecha y hora', value: 'requestedAt' },
        { text: 'Tipo', value: 'exportType' },
        { text: 'Contrato', value: 'contrato' },
        { text: 'Estados', value: 'estados' },
        { text: 'Estado', value: 'state' },
        { text: '', value: 'actions', align: 'end' }
      ];
    },

    emptyText() {
      return this.loading ? 'Cargando...' : 'No tienes exportaciones solicitadas todavía';
    }
  },
  methods: {
    stateMeta(state) {
      return STATE_META[state] || { label: state, color: 'grey', icon: 'mdi-help-circle-outline' };
    },

    // Solo la exportación de membresías se filtra por estado; las solicitudes antiguas, sin
    // exportType, son de membresías.
    hasStatusFilter(item) {
      return !item.exportType || item.exportType === EXPORT_TYPES.MEMBERSHIPS;
    },

    exportTypeLabel(item) {
      return EXPORT_TYPE_LABELS[item.exportType] || EXPORT_TYPE_LABELS[EXPORT_TYPES.MEMBERSHIPS];
    },

    isReady(item) {
      return item.state === EXPORT_REQUEST_STATUS.READY;
    },

    filterStatusCodes(item) {
      const status = item.filters && item.filters.status;
      if (!status || status.length === 0) return [];
      return status.map(code => Number(code));
    }
  }
};
</script>
